import { Platform } from "react-native";

const SkipLink = Platform.OS === "web" ? require("./SkipLink.web").default : require("./SkipLink.native").default;

export default SkipLink;
